<template>
    <div class="brandDetails">
        <div class="scrollBox">
            <div class="scrollContent">
                <div class="branDetailsBox">
                    <div class="headBox">
                        <div class="imgBox" v-if="itemData.logoUrl">
                            <img class="imgStyle" :src="'/manager/fileserver/file/download?id='+itemData.logoUrl" />
                        </div>
                        <div class="headtitle">
                            <div class="headtitleItem" v-if="itemData.brandNa">{{itemData.brandNa}}</div>
                            <div class="headtitleItem" v-if="itemData.linkman">{{itemData.linkman}}</div>
                            <div class="headtitleItem" >{{itemData.floorId}}</div>
                            <div class="headtitleItem" v-if="itemData.telephone" @click="gotoPhone(itemData.telephone)">{{itemData.telephone}}
                                <i class="iconfont icondianhua"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="branDetailsVBox">
                    <div class="brandMar">
                        <div class="branTitel">
                            {{itemData.advNa}}
                            <i class="iconfont iconpinpai1"></i>
                        </div>
                        <div class="brandImgText" v-html="itemData.advIntroduce">

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "shopDetails",
        data(){
            return {
                itemData:''
            }
        },
        mounted() {
            document.title = "广告详情"
            this.itemData = JSON.parse(this.$route.query.itemData)
            this.itemData.advIntroduce = this.itemData.advIntroduce.replace(/[\r\n]/g,"<br/>").replace(/\s/g,"&nbsp;")

        },
        methods:{

        }
    }
</script>

<style lang="scss" scoped>
    .brandDetails{
        position: relative;
        width: 100%;
        height: 100%;
        .scrollBox{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;
        }
        .scrollContent{
            width: 100%;
        }
        .branDetailsBox{
            margin-top: 1px;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: #fff;
        }
        .headBox{
            width: 88%;
            height: 120px;
            display: flex;
            align-items: center;
        }
        .imgBox{
            width: 143px;
            height: 88px;
            border: 1px solid #f1f1f1;
        }
        .imgStyle{
            width: 100%;
            height: 100%;
        }
        .headtitle{
            width: 190px;
            /*height: 70px;*/
            margin-left: 10px;
        }
        .headtitleItem{
            font-size: 14px;
            color: #666;
            height: 22px;
            line-height: 22px;
        }
        .branDetailsVBox{
            margin-top: 8px;
            background-color: #fff;
        }
        .icondianhua{
            font-size: 14px;
            color: #66ccff;
            margin-left: 4px;
        }
        .branTitel{
            font-size: 14px;
        }
        .brandMar{
            width: 90%;
            margin: auto;
            padding-top: 15px;
            padding-bottom: 20px;
            color: #444;
        }
        .iconpinpai1{
            font-size: 14px;
            color: #888;
        }
        .brandImgText{
            font-size: 14px;
            color: #888;
            margin-top: 17px;
            line-height: 23px;
            letter-spacing: 1px;
            font-family: "微软雅黑";
            padding-bottom: 25px;
            text-indent: 30px;
        }
        .brandImgBox{
            width: 150px;
            height: 130px;
            border: 1px solid #dfdfdf;
            float: left;
            margin: 0 13px 0px 0;
        }
        .brandImgStyle{
            width: 100%;
            height: 100%;
        }
    }
</style>
